<div class="loading text-center">
  <img src="/assets/loading.gif" />
</div>
